<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="modal">
    <div class="modal__close">
      <font-awesome-icon icon="times" @click="onCloseClick" />
    </div>
    <div class="modal__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: $modal-background;
  border: $modal-border;
  min-width: 5em;
  min-height: 5em;
  z-index: 1000;
  padding: 1em;
  pointer-events: all;
  user-select: all;
  max-width: 400px;
  width: 90%;
  user-select: none;

  &__close {
    text-align: right;
    cursor: pointer;
  }

  .button > a {
    padding: 1em;
  }
}
</style>

<script>
export default {
  props: {
    year: Number,
    county: Object,
    municipality: Object
  },

  methods: {
    onCloseClick (ev) {
      this.$emit('close', ev)
    }
  }
}
</script>
